// Kept apart from contract-form.component.ts so eagerly loaded pages can use it
// without pulling the lazy-loaded contract form into the initial bundle.

/** systemKey of the standard "Gesellschaftsvertrag" type. */
export const ARTICLES_OF_ASSOCIATION_TYPE_KEY = 'articles_of_association';

/**
 * Navigation state for opening "Vertrag hinzufügen" from another form (e.g. Gesellschaft erstellen):
 * the type is preset and locked, and after saving the form returns to returnUrl with the new id.
 */
export interface ContractFormPresetState {
  presetContractTypeKey: string;
  returnUrl: string;
}
